import styled from 'styled-components'

export const Container = styled.div`
  padding: 10px 10px 20px 30px;
`

export const IntroText = styled.div`
  font-family: 'Roboto', sans-serif;
  padding: 40px 0px 0px 0px;
  line-height: 1.6;
  white-space: pre-wrap;
`
